import React from 'react';
import zxcvbn from 'zxcvbn';

interface IProps {
  password: string;
  updateScore: any;
}

const PasswordStrengthMeter: React.FC<IProps> = function ({ password, updateScore }) {
  const [score, feedback] = React.useMemo(() => {
    const res = zxcvbn(password ?? '');
    return [res.score, res.feedback];
  }, [password]);

  const suggestions = React.useMemo(() => {
    return feedback.suggestions.map((s) => <p>{s}</p>);
  }, [feedback]);

  React.useEffect(() => {
    if (score) {
      updateScore(score);
    }
  }, [score]);

  return (
    <div>
      <div className="mb-2 mt-3 flex items-center justify-between">
        <div className="text-sm font-medium text-gray-500">Password Strength</div>

        <div className={`password-desc pass-s-${!!password && score}`}></div>
      </div>
      <div className="progress password-indicator">
        <div className={`progress-bar password-indicator-score pass-s-${score}`} />
      </div>
      {!!password && (
        <>
          <div className={`mb-4 text-left text-sm font-medium text-rose-500`}>
            {feedback.warning}
          </div>
          <div className="mb-4 text-left text-sm font-medium text-gray-500">{suggestions}</div>
        </>
      )}
    </div>
  );
};

export default PasswordStrengthMeter;
